module.exports = __webpack_public_path__ + "img/687914ca5e2f97a2eeab7a48d1702447.png";